<template>
  <div>
    <ts-loading-banner :loading="class_search">
      <form>
        <fieldset>
          <legend>{{ $t('studentEnrollment.classOperation') }}</legend>
          <div class="row form-group">
            <div class="col-md-12">
              <div id="container-class-operation" class="overflow-auto">
                <table id="class-operation-table" class="table table-hover ui-table ts-table">
                  <thead>
                    <tr>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.className') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.intake') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.teacherName') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.studyTime') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.termName') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.startTerm') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.year') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.semester') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.room') }}
                      </th>

                    </tr>
                    <tr>
                      <th colspan="9">
                        <input type="text" class="form-control" :placeholder="$t(
                          'studentEnrollment.searchClassNameAndTeacherName'
                        )
                          " v-model="class_search_value" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in operationClassResources" :key="index" @dblclick="selectedClass(item)">
                      <td class="ts-whitespace-no-wrap" :class="{
                        'selected-class': item.class_id == model.class_id
                      }">
                        {{ item.class_name }}
                      </td>
                      <td class="ts-whitespace-no-wrap" :class="{
                        'selected-class': item.class_id == model.class_id
                      }">
                        {{
                          item.intake
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap" :class="{
                        'selected-class': item.class_id == model.class_id
                      }">
                        {{
                          item.teacher
                            ? item.teacher.fname_foreign +
                            ' ' +
                            item.teacher.lname_foreign
                            : null
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap" :class="{
                        'selected-class': item.class_id == model.class_id
                      }">
                        {{
                          item.academic_study_times
                            ? item.academic_study_times.study_time
                            : ' '
                        }}

                        {{
                          item.academic_study_times
                            ? item.academic_study_times.session
                            : ''
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap" :class="{
                        'selected-class': item.class_id == model.class_id
                      }">
                        {{ item.term.term_name }}
                      </td>
                      <td class="ts-whitespace-no-wrap" :class="{
                        'selected-class': item.class_id == model.class_id
                      }">
                        {{ item.term.term_start }}
                      </td>
                      <td class="ts-whitespace-no-wrap" :class="{
                        'selected-class': item.class_id == model.class_id
                      }">
                        {{ item.academic_year }}
                      </td>
                      <td class="ts-whitespace-no-wrap" :class="{
                        'selected-class': item.class_id == model.class_id
                      }">
                        {{ item.academic_term }}
                      </td>
                      <td class="ts-whitespace-no-wrap" :class="{
                        'selected-class': item.class_id == model.class_id
                      }">
                        {{
                          item.room
                            ? item.room.room_name
                            : ' '
                        }}
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'classOperationEnrollment',
  props: ['value'],
  data() {
    return {
      model: {},
      class_search: false,
      class_search_value: '',
      operationClassResources: []
    }
  },
  created() {
    this.model = this.value
    this.fetchClassOperation({ perPage: 15 })
  },
  methods: {
    ...mapActions('studentEnrollment', ['getClassOperation']),
    fetchClassOperation(params) {
      this.class_search = true
      this.operationClassResources = []
      this.getClassOperation(params)
        .then(response => {
          this.operationClassResources = response.data
        })
        .finally(() => {
          this.class_search = false
        })
    },
    selectedClass(item) {
      this.model.class_id = item.class_id
      this.model.student_id_list = []
    }
  },
  watch: {
    class_search_value: debounce(function (value) {
      this.operationClassResources = []
      this.model.class_id = ''
      if (value) {
        this.fetchClassOperation({ search: value, page: -1 })
      } else {
        this.fetchClassOperation({ perPage: 15 })
      }
    }, 500)
  }
}
</script>

<style lang="css" scoped>
#container-class-operation {
  height: 70vh;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px;
  /* Remove scrollbar space */
  background: transparent;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}

::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}

#class-operation-table>thead>tr>th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}

.selected-class {
  border-bottom: 1px solid #69bafb;
  border-top: 1px solid #69bafb;
  background: #ade0f0;
}

#class-operation-table>tbody>tr>td {
  cursor: pointer;
}

.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
</style>
